import { api } from '@/helpers/core'
import { AxiosResponse } from 'axios'

export interface Property {
	name: string
	path: string
	definitionName: string
}

export interface Section {
	base: string[]
	aux: string[]
}

export interface PropertiesResponse {
	all: Property[]
	Filter: Section
	Projection: Section
	Graph: Section
}

export default {
	get (): Promise<AxiosResponse<PropertiesResponse>> {
		return api.get('/settings/properties/')
	},
	replace ({ name, property, value }: { name: string, property: string, value?: number }): Promise<AxiosResponse<Record<string, string[]>>> {
		return api.post('/settings/properties/replace', { name, property, value })
	},
	update (property: Property): Promise<AxiosResponse<Property>> {
		return api.post('/settings/properties/', property)
	},
	delete (property: Property): Promise<AxiosResponse<void>> {
		return api.post('/settings/properties/delete', property)
	}
}
